import React, { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Context as StoreContext } from '../../../providers/StoreContextProvider';
import VendorMediaTableView from './VendorMediaTableView';

const VendorContentView = () => {
  const {} = useContext(StoreContext);

  return (
    <Routes>
      <Route element={<VendorMediaTableView />} path="/media" />
      <Route
        element={<Navigate replace to="/merchant/content/media" />}
        path="*"
      />
    </Routes>
  );
};

export default VendorContentView;
